import { render, staticRenderFns } from "./ProfileRatingWidget.vue?vue&type=template&id=b193958c&"
import script from "./ProfileRatingWidget.vue?vue&type=script&lang=js&"
export * from "./ProfileRatingWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProfileRatingWidget.vue?vue&type=style&index=0&id=b193958c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports